import { UserInterface } from '../../Shared/interfaces/user/UserInterfaces';

// Columns to exclude from the users table
export const EXCLUDED_COLUMNS = ['userStatus'];
export const USER_ROLE_FIELD = 'userRole';
export const DATE_FIELDS = ['lastUpdatedAt', 'createdAt'] as const;
export const PRIVILEGED_MODE_FIELD = 'privilegedMode';

export enum PrivilegedModeValue {
  ON = 'ON',
  OFF = 'OFF',
}

export const PRIVILEGED_MODE_OPTIONS = [
  { value: PrivilegedModeValue.ON, labelKey: 'privileged-mode-on' },
  { value: PrivilegedModeValue.OFF, labelKey: 'privileged-mode-off' },
];

export const USER_TABLE_HEADERS = {
    actions: 'actions-user-table-header',
    userId: 'user-id-user-table-header',
    firstName: 'first-name-user-table-header',
    lastName: 'last-name-user-table-header',
    emailId: 'email-id-user-table-header',
    userRole: 'user-role-user-table-header',
    category: 'category-user-table-header',
    orgName: 'org-name-user-table-header',
    createdAt: 'created-at-user-table-header',
    lastUpdatedAt: 'last-updated-at-user-table-header',
    privilegedMode: 'privileged-mode-user-table-header',
    userStatus: 'user-status-user-table-header',
};


export const SEARCHABLE_USER_FIELDS: Partial<Record<keyof UserInterface, string>> = {
    userId: 'User ID',
    firstName: 'First Name',
    lastName: 'Last Name',
    emailId: 'Email',
    userRole: 'User Role',
    createdAt: 'Created Date',
    lastUpdatedAt: 'Last Updated',
    category: 'Category',
};
